import { useState } from "react";
import { X, UserPlus, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";

export default function ConvertLeadModal({ lead, onClose, onConverted }) {
  var navigate = useNavigate();
  var formState = useState({
    name: lead.name || "",
    email: lead.email || "",
    phone: lead.phone || "",
    cpf: "",
    password: "Methos@2026",
    address: "",
    birth_date: "",
    notes: "",
  });
  var form = formState[0];
  var setForm = formState[1];
  var loadingState = useState(false);
  var loading = loadingState[0];
  var setLoading = loadingState[1];
  var errorState = useState(null);
  var error = errorState[0];
  var setError = errorState[1];
  var successState = useState(null);
  var success = successState[0];
  var setSuccess = successState[1];

  function updateField(field, value) {
    setForm(function(prev) { var n = {}; for (var k in prev) n[k] = prev[k]; n[field] = value; return n; });
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim()) return;
    if (form.password.length < 6) { setError("Senha deve ter no minimo 6 caracteres"); return; }
    setLoading(true);
    setError(null);
    try {
      var res = await api.post("/leads/" + lead.id + "/convert", {
        name: form.name.trim(),
        email: form.email.trim(),
        phone: form.phone.trim(),
        cpf: form.cpf.trim(),
        password: form.password,
        address: form.address.trim(),
        birth_date: form.birth_date.trim(),
        notes: form.notes.trim(),
      });
      setSuccess(res.data);
    } catch (err) {
      var detail = err.response?.data?.detail || "Erro ao converter lead";
      setError(typeof detail === "string" ? detail : "Erro ao converter lead");
    } finally {
      setLoading(false);
    }
  }

  function handleGoToProfile() {
    if (success && success.client_id) {
      navigate("/clientes/" + success.client_id);
    }
  }

  function handleClose() {
    if (success) onConverted();
    else onClose();
  }

  return (
    <>
      <div className="fixed inset-0 bg-black/40 z-50" onClick={handleClose} />
      <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 w-full max-w-lg" data-testid="convert-lead-modal">
        <div className="bg-white rounded-2xl shadow-2xl max-h-[85vh] overflow-y-auto">
          <div className="flex items-center justify-between p-5 border-b border-gray-100">
            <div className="flex items-center gap-2">
              <UserPlus className="w-5 h-5 text-emerald-500" />
              <h2 className="text-lg font-bold text-[#0A2F3D]">Cadastrar Cliente</h2>
            </div>
            <button onClick={handleClose} className="p-2 hover:bg-gray-100 rounded-lg" data-testid="convert-modal-close">
              <X className="w-5 h-5 text-gray-500" />
            </button>
          </div>

          {success ? (
            <div className="p-5 space-y-4">
              <div className="bg-emerald-50 border border-emerald-100 rounded-xl p-4 text-center" data-testid="convert-success">
                <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <UserPlus className="w-6 h-6 text-emerald-600" />
                </div>
                <p className="text-sm font-semibold text-emerald-800">Cliente cadastrado com sucesso!</p>
                <p className="text-xs text-emerald-600 mt-1">{success.client_name} ({success.client_email})</p>
              </div>
              <div className="flex gap-3">
                <button onClick={handleClose} className="flex-1 px-4 py-2.5 border border-gray-200 rounded-xl text-sm font-medium text-gray-600 hover:bg-gray-50">
                  Fechar
                </button>
                <button onClick={handleGoToProfile} className="flex-1 px-4 py-2.5 bg-[#3B82F6] text-white rounded-xl text-sm font-medium hover:bg-[#2563EB] flex items-center justify-center gap-2" data-testid="convert-go-profile">
                  Ver Ficha <ArrowRight className="w-4 h-4" />
                </button>
              </div>
            </div>
          ) : (
            <>
              <div className="mx-5 mt-3 px-4 py-2.5 rounded-lg text-xs bg-blue-50 text-blue-700 border border-blue-100">
                Convertendo lead <strong>{lead.name}</strong> em cliente. Preencha os dados complementares.
                {lead.referral && <span className="block mt-1 text-blue-600">Indicado por: <strong>{lead.referral}</strong></span>}
              </div>
              <div className="mx-5 mt-2 px-4 py-2 rounded-lg text-xs bg-emerald-50 text-emerald-700 border border-emerald-100">
                Senha padrao pre-preenchida: <strong>Methos@2026</strong> — pode alterar se desejar.
              </div>
              {error && <div className="mx-5 mt-3 px-4 py-2.5 rounded-lg text-sm bg-red-50 text-red-700 border border-red-200">{error}</div>}
              <form onSubmit={handleSubmit} className="p-5 space-y-4">
                <div className="grid grid-cols-2 gap-3">
                  <div className="col-span-2">
                    <label className="block text-xs font-medium text-gray-600 mb-1.5">Nome Completo *</label>
                    <input type="text" value={form.name} onChange={function(e) { updateField("name", e.target.value); }}
                      className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30 focus:border-[#3B82F6]"
                      placeholder="Nome completo" required data-testid="convert-form-name" />
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-gray-600 mb-1.5">Email *</label>
                    <input type="email" value={form.email} onChange={function(e) { updateField("email", e.target.value); }}
                      className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30 focus:border-[#3B82F6]"
                      placeholder="email@exemplo.com" required data-testid="convert-form-email" />
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-gray-600 mb-1.5">Telefone</label>
                    <input type="tel" value={form.phone} onChange={function(e) { updateField("phone", e.target.value); }}
                      className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30 focus:border-[#3B82F6]"
                      placeholder="(11) 99999-9999" data-testid="convert-form-phone" />
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-gray-600 mb-1.5">CPF</label>
                    <input type="text" value={form.cpf} onChange={function(e) { updateField("cpf", e.target.value); }}
                      className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30 focus:border-[#3B82F6]"
                      placeholder="000.000.000-00" data-testid="convert-form-cpf" />
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-gray-600 mb-1.5">Data de Nascimento</label>
                    <input type="date" value={form.birth_date} onChange={function(e) { updateField("birth_date", e.target.value); }}
                      className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30 focus:border-[#3B82F6]"
                      data-testid="convert-form-birth" />
                  </div>
                  <div className="col-span-2">
                    <label className="block text-xs font-medium text-gray-600 mb-1.5">Endereco</label>
                    <input type="text" value={form.address} onChange={function(e) { updateField("address", e.target.value); }}
                      className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30 focus:border-[#3B82F6]"
                      placeholder="Rua, numero, bairro, cidade - UF" data-testid="convert-form-address" />
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-gray-600 mb-1.5">Senha de Acesso *</label>
                    <input type="text" value={form.password} onChange={function(e) { updateField("password", e.target.value); }}
                      className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30 focus:border-[#3B82F6]"
                      placeholder="Minimo 6 caracteres" data-testid="convert-form-password" />
                    <p className="text-xs text-gray-400 mt-1">Senha para o cliente acessar a area logada</p>
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-gray-600 mb-1.5">Observacao</label>
                    <input type="text" value={form.notes} onChange={function(e) { updateField("notes", e.target.value); }}
                      className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30 focus:border-[#3B82F6]"
                      placeholder="Nota interna" data-testid="convert-form-notes" />
                  </div>
                </div>
                <div className="flex gap-3 pt-1">
                  <button type="button" onClick={onClose} className="flex-1 px-4 py-2.5 border border-gray-200 rounded-xl text-sm font-medium text-gray-600 hover:bg-gray-50">
                    Cancelar
                  </button>
                  <button type="submit" disabled={loading}
                    className="flex-1 px-4 py-2.5 bg-emerald-500 text-white rounded-xl text-sm font-medium hover:bg-emerald-600 disabled:opacity-50 flex items-center justify-center gap-2"
                    data-testid="convert-form-submit">
                    {loading ? "Cadastrando..." : "Cadastrar Cliente"}
                    {!loading && <UserPlus className="w-4 h-4" />}
                  </button>
                </div>
              </form>
            </>
          )}
        </div>
      </div>
    </>
  );
}
